import { useQuery } from "@tanstack/react-query";
import { getContactSection } from "../../api/apiContactSection";

export const useGetContactSection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["contact-section"],
        queryFn: getContactSection,
    });

    return {
        contactSection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
